var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeidiland = function SvgHeidiland(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 342 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "heidiland_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 342,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.527 0H0v87.781h341.527V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#heidiland_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.875 8.735a8.735 8.735 0 1 1 17.47.01 8.735 8.735 0 0 1-17.47-.01ZM42.507 87.777h-14.08V62.883H14.084v24.903H.005V27.409h14.08v23.585H28.43V27.41h14.08l-.004 60.367ZM62.563 28.683v12.236h18.563v11.353H62.563V65.65H87.29v11.7H48.482V16.983H87.29v11.7H62.563ZM103.801 27.405h-14.08v60.372h14.08V27.405ZM124.37 65.997h.45a12.88 12.88 0 0 0 12.938-6.426 25.002 25.002 0 0 0 3.348-13.027 22.876 22.876 0 0 0-4.311-13.64 12.848 12.848 0 0 0-11.88-4.838h-.527l-.018 37.931Zm-.9-49.019c8.712 0 16.2.527 22.793 6.777a31.174 31.174 0 0 1 9.328 23.23 32.76 32.76 0 0 1-7.83 22 27.231 27.231 0 0 1-21.915 8.361h-15.574V16.978h13.198ZM174.627 27.405h-14.081v60.372h14.081V27.405ZM215.352 65.385v11.97h-34.056V16.983h14.081v48.402h19.975Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.218 64.282-6.044-21.208-6.043 21.209h12.087Zm20.862 23.5h-14.324l-3.478-12.407h-18.383l-3.559 12.406h-11.678l18.216-60.367h15.399l17.802 60.367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.877 77.35h-12.056L257.993 36.78h-.355V77.35h-10.913V16.983h15.228l15.84 35.465h.176V16.982h10.912l-.004 60.367ZM310.288 76.428h.45a12.883 12.883 0 0 0 12.937-6.426 25.015 25.015 0 0 0 3.344-13.023 22.861 22.861 0 0 0-4.311-13.64 12.836 12.836 0 0 0-11.885-4.837h-.522l-.013 37.926Zm-.901-49.018c8.712 0 16.201.526 22.793 6.777a31.16 31.16 0 0 1 9.329 23.229 32.782 32.782 0 0 1-7.83 22 27.246 27.246 0 0 1-21.915 8.361h-15.575V27.41h13.198ZM87.898 8.307v.423a8.735 8.735 0 0 0 17.469 0v-.423M159.065 8.735a8.73 8.73 0 0 1 5.396-8.067 8.734 8.734 0 1 1-5.396 8.067Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.084 8.307v.423a8.735 8.735 0 1 0 17.469 0v-.423"
  }))));
};
export default SvgHeidiland;